
















































import { Component, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import Logo from "@/components/Logo.vue";
import Textfield from "@/components/Textfield.vue";
import Button from "@/components/Button.vue";

const namespace = "auth";

@Component({
  components: {
    appLogo: Logo,
    appTextfield: Textfield,
    appButton: Button
  }
})
export default class Login extends Vue {
  @Action("login", { namespace }) login!: (payload: {
    email: string;
    password: string;
  }) => void;

  @Getter("errors", { namespace }) errors!: Array<any>;
  @Getter("logging", { namespace }) logging!: boolean;

  email = "";
  password = "";

  onSubmit(): void {
    this.login({ email: this.email, password: this.password });
    this.email = "";
    this.password = "";
  }
}
